module.exports = __webpack_public_path__ + "media/honey-icons/icon-white-84bd754e.svg";